<nav class="ba-jumpnav" aria-label="Sprunglinks">
    <a href="#main" tabindex="0">{{ 'navigation.skipToMainContent'|i18next }}</a>
</nav>
<bahf-header hfconfig='{"languages": [{"code": "de"}, {"code": "en"}, {"code": "es"}]}'></bahf-header>
<bahf-fallback-header></bahf-fallback-header>

<router-outlet></router-outlet>

@if (isLoading()) {
    <div class="ba-loading"></div>
}

@if (enableOAuth) {
    <oiam-oauth-component></oiam-oauth-component>
    <oiam-oauth-fallback></oiam-oauth-fallback>
}

<bahf-footer></bahf-footer>
<bahf-fallback-footer></bahf-fallback-footer>
